module.exports = __webpack_public_path__ + "img/technology2.afd6c0c2.png";